import React, {useState} from 'react';
import {useControllerProps} from '../../Widget/ControllerContext';
import {
  FoldableSummarySection,
  FoldableSummarySectionDataHook,
} from '../../../../common/components/FoldableSummarySection/FoldableSummarySection';
import {BiFoldableSummaryAction, BiMobilePosition} from '../../../../domain/utils/bi.util';
import {isLineItemErrorViolationExist} from '../LineItem/LineItem.utils';
import {getTotal} from '../../../../domain/utils/total.util';
import {CartSummary} from '../CartSummary';
import {TotalUpdateSkeleton} from '../TotalUpdateSkeleton';

export const TopMobileSummary = () => {
  const {
    checkoutStore: {onMobileFoldableSummaryToggle, cart, cartSummary, shouldShowViolations, isCartSummaryUpdating},
  } = useControllerProps();
  const shouldShowErrorIcon = Boolean(
    !!cart.noItemsError ||
      !!cart.hasOutOfStockLineItems ||
      (cartSummary &&
        (!!cartSummary.errors.couponError ||
          !!cartSummary.errors.giftCardError ||
          (shouldShowViolations && isLineItemErrorViolationExist(cartSummary.violations))))
  );

  const [isOpen, setIsOpen] = useState(false);
  const toggleFoldableSummarySection = () => {
    const isSummaryOpen = !isOpen;
    setIsOpen(isSummaryOpen);
    onMobileFoldableSummaryToggle(BiMobilePosition.top, {
      origin: 'top',
      action: isSummaryOpen ? BiFoldableSummaryAction.open : BiFoldableSummaryAction.close,
    });
  };

  return (
    <>
      <FoldableSummarySection
        onClick={toggleFoldableSummarySection}
        isOpen={isOpen}
        shouldShowErrorIcon={shouldShowErrorIcon}
        total={
          cartSummary && !isCartSummaryUpdating ? (
            <span data-hook={FoldableSummarySectionDataHook.totalValue}>{getTotal(cartSummary)}</span>
          ) : (
            <TotalUpdateSkeleton />
          )
        }
      />
      {isOpen && (
        <CartSummary showSlots={false} shouldShowNumberOfItems={false} mobilePosition={BiMobilePosition.top} />
      )}
    </>
  );
};
